import lodash from 'lodash'
import { BAG_REQUEST_LIST_COLUMN } from '../constants'

const SETTING_OPTIONS = [
    {
        key: BAG_REQUEST_LIST_COLUMN.BAGGING_REQUEST_CODE,
        selected: true,
        disabled: true,
    },
    {
        key: BAG_REQUEST_LIST_COLUMN.MIDMILE_SHIPPING_PARTNER,
        selected: true,
    },
    {
        key: BAG_REQUEST_LIST_COLUMN.WAREHOUSE_INPUT,
        selected: true,
    },
    {
        key: BAG_REQUEST_LIST_COLUMN.CREATED_AT,
        selected: true,
    },
    {
        key: BAG_REQUEST_LIST_COLUMN.FINISHED_AT,
        selected: true,
    },
    {
        key: BAG_REQUEST_LIST_COLUMN.STATUS,
        selected: true,
    },
    {
        key: BAG_REQUEST_LIST_COLUMN.NUM_PACKAGE,
        selected: true,
    },
]

class SettingService {
    constructor(options) {
        this.options = options
    }

    getSetting() {
        let setting = localStorage.getItem('bag_request_list_setting')
        return setting ? JSON.parse(setting) : {}
    }

    updateSetting(setting) {
        localStorage.setItem('bag_request_list_setting', JSON.stringify(setting))
    }

    getOption() {
        let options = []
        lodash.each(SETTING_OPTIONS, option => {
            options.push(option)
        })
        this.options = options
    }

    getPageSetting(userId) {
        let defaultSetting = lodash.get(this.getSetting(), userId, this.getDefaultSetting())
        let settings = []
        lodash.each(SETTING_OPTIONS, setting => {
            if (defaultSetting.includes(setting.key)) {
                settings.push(setting.key)
            }
        })
        return settings
    }

    getDefaultSetting() {
        return this.options.filter(option => option.selected).map(option => option.key)
    }

    getUserSetting(userId) {
        this.getOption()
        return this.getPageSetting(userId)
    }

    updateUserSetting(userId, setting) {
        this.getOption()
        this.updateSetting({ ...this.getSetting(), [userId]: setting })
    }
}

let settingService = new SettingService(SETTING_OPTIONS)

export default settingService
